module.exports = __webpack_public_path__ + "static/media/Brianna.fc7f665d.png";